import { render } from "./HRField.vue?vue&type=template&id=10b20db0"
import script from "./HRField.vue?vue&type=script&lang=js"
export * from "./HRField.vue?vue&type=script&lang=js"

import "./HRField.vue?vue&type=style&index=0&id=10b20db0&lang=scss"

import exportComponent from "/home/jenkins/workspace/DeputyApp_web-hr_202604021339/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__